const cs = {
    '/': {
        title: '{brand} & Sportovní Sázení | Okamžité Výběry',
        description: '{brand} a sportovní sázení v jedné peněžence. Automaty, live kasino a sázení na sport s okamžitými výběry v kryptu.',
        keywords: 'krypto kasino, bitcoin kasino, sportovní sázení kryptem, online automaty, okamžitý výběr, provably fair kasino'
    },
    '/casino': {
        title: '{brand} Online Casino | Automaty, Blackjack & Live Dealeři',
        description: 'Automaty, blackjack, ruleta & live dealeři u {brand}. Stovky her, rychlé krypto vklady & okamžité výběry dostupné 24/7.',
        keywords: 'krypto kasino, bitcoin kasino hry, online kasino, krypto automaty, live kasino, blackjack, ruleta'
    },
    '/sports': {
        title: '{brand} Online Sportovní Sázení | Krypto Sázky & Kurzy',
        description: 'Sázejte na sport u {brand}. Konkurenční kurzy na fotbal, basketbal & další. Live sázení, bezpečné krypto sázky & rychlé výplaty.',
        keywords: 'sportovní sázení kryptem, bitcoin sázková kancelář, live sázky, kurzy na fotbal, esports sázky'
    },
    '/livecasino': {
        title: '{brand} Live Casino | Blackjack, Ruleta & Live Dealeři',
        description: 'Blackjack, ruleta & live casino hry u {brand}. Praví dealeři, HD streaming & široký výběr live stolů dostupných 24/7.',
        keywords: 'live kasino, živí krupiéři, live blackjack, live ruleta, live baccarat, herní show'
    },
    '/slots': {
        title: '{brand} Online Automaty | Velký Výběr Casino Slotů',
        description: 'Obrovská sbírka automatů u {brand}. Klasické ovocné automaty, video sloty & progresivní jackpoty - vše hratelné s kryptem.',
        keywords: 'krypto automaty, bitcoin automaty, online automaty, video automaty, megaways automaty, nákup bonusu'
    },
    '/vip': {
        title: '{brand} VIP Program | Exkluzivní Odměny & Výhody',
        description: 'VIP program {brand}: exkluzivní odměny, personalizované bonusy a prioritní podpora. Výhody přizpůsobené věrným hráčům.',
        keywords: 'vip program kasina, rakeback, věrnostní odměny, high roller kasino, vip úrovně'
    },
    '/welcome-offer': {
        title: '{brand} Uvítací Bonus | Krypto Casino',
        description: 'Získejte uvítací nabídku {brand}. Začněte s kryptem a využijte bonusy pro nové hráče při prvním vkladu.',
        keywords: 'uvítací bonus kasino, krypto kasino bonus, bonus za první vklad, nabídka pro nové hráče'
    },
    '/referral': {
        title: '{brand} Referral Program | Pozvěte Přátele & Získejte Odměny',
        description: 'Pozvěte přátele na {brand} & získejte odměny, když se zaregistrují a začnou hrát. Sdílejte odkaz a sbírejte bonusy za každé doporučení.',
        keywords: 'referral program kasina, bonus za pozvání přítele, partnerské odměny'
    },
    '/promotion-page': {
        title: '{brand} Casino Akce | Bonusy & Speciální Nabídky',
        description: 'Prohlédněte si nejnovější akce {brand}. Aktuální bonusy, turnaje & speciální akce - uplatněte svoji nabídku a začněte hrát.',
        keywords: 'akce kasina, krypto kasino bonusy, týdenní závod, kasino turnaje'
    },
    '/featurebuyin': {
        title: '{brand} Feature Buy-In Sloty | Přeskočte na Bonusové Kolo',
        description: 'Přeskočte přímo na bonusová kola se sloty s feature buy-in u {brand}. Okamžitě aktivujte bonusové funkce pro šanci na velké výhry.'
    },
    '/gameshows': {
        title: 'Live Game Show | Hrajte Casino Herní Show u {brand}',
        description: 'Hrajte live casino herní show u {brand}. Vychutnejte si Crazy Time, Monopoly Live & další, vedené profesionálními dealery v reálném čase.'
    },
    '/newgames': {
        title: '{brand} Nové Casino Hry | Nejnovější Sloty & Live Hry',
        description: 'Hrajte nejnovější casino hry u {brand}. Pravidelně aktualizováno o nové sloty & stolní hry od předních poskytovatelů. Buďte první, kdo hraje.'
    },
    '/populargames': {
        title: '{brand} Populární Casino Hry | Nejlepší Sloty & Live Hry',
        description: 'Hrajte nejoblíbenější casino hry u {brand}. Nejlépe hodnocené sloty & stolní hry oblíbené naší komunitou, dostupné s kryptem.'
    },
    '/hotslots': {
        title: '{brand} Žhavé Sloty | Nejhranější Automaty',
        description: 'Hrajte nejoblíbenější výherní automaty u {brand}. Nejžhavější sloty současnosti, všechny dostupné s kryptem.'
    },
    '/table_games': {
        title: '{brand} Stolní Hry | Blackjack, Ruleta & Baccarat',
        description: 'Hrajte blackjack, ruletu, baccarat a další stolní hry u {brand}. Vše dostupné s kryptem.'
    },
    '/hotlive': {
        title: '{brand} Žhavé Live Casino | Nejhranější Live Hry',
        description: 'Nejoblíbenější live casino hry u {brand}. Hrajte se skutečnými krupiéry v reálném čase.'
    },
    '/originals': {
        title: '{brand} Originální Casino Hry | Exkluzivní Tituly',
        description: 'Hrajte exkluzivní originální hry u {brand}. Unikátní tituly, které jinde nenajdete, vyvinuté vlastními silami pro nezapomenutelný kasinový zážitek.'
    },
    '/providers': {
        title: '{brand} Herní Poskytovatelé | Partnerská Studia & Software',
        description: 'Prozkoumejte všechny herní poskytovatele u {brand}. Spolupracujeme s předními studii, abychom vám přinesli rozmanitou knihovnu krypto kasina vysoké kvality.'
    },
    '/about-us': {
        title: 'O Nás | Zjistěte Více o {brand}',
        description: 'Zjistěte více o {brand}, předním krypto kasinu & sportovní sázkovně. Zavázáni k bezpečnému, férovému & vzrušujícímu hazardu s okamžitými krypto výběry.'
    },
    '/affiliate': {
        title: 'Affiliatní Program | Vydělávejte Krypto s {brand}',
        description: 'Staňte se partnerem {brand} & vydělávejte provize propagací našeho krypto kasina. Konkurenční sazby, sledování v reálném čase & dedikovaná podpora affiliatů.'
    },
    '/faq': {
        title: '{brand} FAQ | Často Kladené Otázky',
        description: 'Najděte odpovědi na časté otázky ohledně {brand}. Prohlédněte si naše FAQ pro pomoc s účty, platbami, bonusy & kasino hrami.'
    },
    '/aml-policy': {
        title: 'AML Politika | Boj Proti Praní Peněz v {brand}',
        description: 'AML politika {brand} zajišťuje bezpečné, důvěryhodné prostředí. Přečtěte si o našich opatřeních k předcházení nezákonné činnosti na naší platformě.'
    },
    '/bonus-terms': {
        title: 'Podmínky Bonusů | Akce {brand}',
        description: 'Přečtěte si pravidla bonusů & akcí {brand}. Zjistěte, jak nárokovat, využívat & vybírat bonusové výhry z naší platformy.'
    },
    '/complaints-and-arbitration': {
        title: 'Stížnosti a Arbitráž | Podpora Hráčů v {brand}',
        description: 'Seznamte se s procesem řešení stížností & sporů {brand}. Zaručujeme férové zacházení a řešíme problémy hráčů rychle a transparentně.'
    },
    '/fairness': {
        title: 'Prokazatelně Férové Hry | Záruky Férovosti v {brand}',
        description: '{brand} používá technologii prokazatelné férovosti, aby zaručil, že každý výsledek hry je ověřitelný, transparentní & zcela náhodný.'
    },
    '/kyc-policy': {
        title: 'KYC Politika | Znáte Svého Zákazníka v {brand}',
        description: 'KYC politika {brand} popisuje náš proces ověřování totožnosti. Zjistěte, jak chráníme hráče a udržujeme bezpečné herní prostředí.'
    },
    '/payment-policy': {
        title: '{brand} Platební Politika | Krypto Vklady & Výběry',
        description: '{brand} přijímá krypto vklady & výběry. Přečtěte si naši platební politiku ohledně limitů transakcí, přijímaných mincí & dob zpracování.'
    },
    '/privacy-policy': {
        title: 'Zásady Ochrany Soukromí | Ochrana Dat v {brand}',
        description: 'Zásady ochrany soukromí {brand}. Zjistěte, jak shromažďujeme, používáme & chráníme vaše osobní údaje na naší krypto kasinové platformě.'
    },
    '/responsible-gaming': {
        title: 'Odpovědné Hraní | Hrajte Bezpečně v {brand}',
        description: '{brand} se zavazuje k odpovědnému hazardu. Přistupujte k nástrojům & zdrojům pro správu svých hráčských návyků a bezpečnou hru.'
    },
    '/terms-of-service': {
        title: 'Podmínky Služby | {brand}',
        description: 'Přečtěte si podmínky & ujednání upravující vaše používání {brand}. Pochopte svá práva a povinnosti jako hráče.'
    },
    '/terms-sports': {
        title: 'Podmínky Sportovního Sázení | {brand}',
        description: 'Podmínky sportovního sázení {brand}. Pravidla pro uzavírání sázek, výplaty výher & používání sportovní sázkové kanceláře na naší platformě.'
    },
    '/special-bets': {
        title: '{brand} Speciální sázky | Krypto sázková kancelář',
        description: 'Podávejte speciální sázky na {brand}. Trhy na sport, esport & jednorázové události, s okamžitými krypto vklady a rychlými výplatami.'
    },
    '/transparency': {
        title: '{brand} Transparentnost | Prokazatelně férové krypto kasino',
        description: 'Podívejte se, jak {brand} funguje otevřeně. Ověření prokazatelné férovosti her, zveřejněné míry návratnosti z živého katalogu & výplaty on-chain.'
    },
    '/faq/about': {
        title: 'O {brand} | Časté dotazy',
        description: 'O {brand}: licence, jak krypto kasino funguje & čím je platforma férová. Odpovědi na nejčastější otázky.'
    },
    '/faq/account': {
        title: '{brand} Účet | Časté dotazy',
        description: 'Správa účtu na {brand}: registrace, přihlášení, ověření & nastavení profilu. Odpovědi na nejčastější dotazy k účtu.'
    },
    '/faq/bonuses': {
        title: '{brand} Bonusy | Časté dotazy',
        description: 'Bonusy na {brand}: uvítací nabídky, promo kódy, požadavky na protočení & odměny. Odpovědi na nejčastější dotazy k bonusům.'
    },
    '/faq/deposits': {
        title: '{brand} Vklady | Časté dotazy',
        description: 'Jak vložit kryptoměnu na {brand}: podporované mince, sítě, minima & doby potvrzení. Odpovědi na nejčastější dotazy k vkladům.'
    },
    '/faq/games-sports': {
        title: '{brand} Hry & sport | Časté dotazy',
        description: 'Kasinové hry & sportovní sázky na {brand}: poskytovatelé, prokazatelná férovost, kurzy & živé sázení. Odpovědi na nejčastější dotazy.'
    },
    '/faq/responsible-gambling': {
        title: '{brand} Odpovědné hraní | Časté dotazy',
        description: 'Odpovědné hraní na {brand}: limity vkladů, sebevyloučení, přestávky & nástroje podpory pro bezpečnou hru.'
    },
    '/faq/security': {
        title: '{brand} Zabezpečení | Časté dotazy',
        description: 'Zabezpečení na {brand}: ochrana účtu, dvoufaktorové ověření, férovost & ochrana dat. Odpovědi na nejčastější dotazy k bezpečnosti.'
    },
    '/faq/support-disputes': {
        title: '{brand} Podpora & spory | Časté dotazy',
        description: 'Jak získat pomoc na {brand}: živý chat, doby odezvy & jak se řeší spory. Odpovědi na nejčastější dotazy k podpoře.'
    },
    '/faq/withdrawals': {
        title: '{brand} Výběry | Časté dotazy',
        description: 'Jak vybrat kryptoměnu z {brand}: doby výplat, minima, poplatky & limity. Odpovědi na nejčastější dotazy k výběrům.'
    }
};
export default cs;
